import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { StripeService, StripeSessionStatus } from '@services/public';
import { APIErrors, isAPIErrors } from '@util';

@Component({
	selector: 'app-public-purchase-return',
	templateUrl: './return.component.html',
	styleUrls: ['./return.component.scss'],
})
export class PublicPurchaseReturnComponent implements OnInit {
	constructor(
		private _route: ActivatedRoute,
		private _router: Router,
		private _stripeSvc: StripeService,
	) {}

	ngOnInit(): void {
		this._route.queryParamMap.subscribe((value: ParamMap) => {
			if (!value.has('sessionID')) {
				this._router.navigate(['login']);
				return;
			}
			this._stripeSvc
				.getStatus(value.get('sessionID'))
				.subscribe((res: StripeSessionStatus | APIErrors) => {
					if (!isAPIErrors(res)) {
						if (res.status === 'complete')
							window.location.href =
								'https://jakapa.com/thank-you-individual-user-subscription/';
						else if (res.productID)
							this._router.navigate([`purchase?productID=${res.productID}`]);
						else this._router.navigate(['login']);
					}
				});
		});
	}
}
